class featuredCollectionSlider {
  constructor(parent) {
    if(!parent || parent.length === 0) {
      return;
    }
    this.parent = parent;
    this.init();
  }

  init = () =>{
    const elements = qsa('.featured-collection-slider-js');
    elements.forEach((item)=>{
      this.swiper(item)
    })
  }
 
  swiper = (element) => {
    let navigation = element.getAttribute("data-navigation") == "true" ? true : false;
    let slidesPerView = parseInt(element.getAttribute('data-slide-per-view'));
    let elId = element.getAttribute("data-id");
    let spaceBetween = 20;
    if (window.innerWidth < 749) {
      slidesPerView = parseInt(element.getAttribute('data-m-slide-per-view')) + .5;
      spaceBetween = 11
    }

    if (window.innerWidth > 750 && window.innerWidth < 990) {
      slidesPerView: 3;
      spaceBetween = 15
    }
 
    if (navigation) {
      navigation = {
        nextEl: `.${elId} .swiper-button-next.featured-collection-slider-arrow`,
        prevEl: `.${elId} .swiper-button-prev.featured-collection-slider-arrow`,
      };
    }
 
    let swiper = new Swiper(element, {
      // Optional parameters
      navigation,
      slidesPerView,
      spaceBetween
    });
  };
}
// Initialize with the elements
new featuredCollectionSlider(qsa('.section-featured-collection-slider'));